import { render, staticRenderFns } from "./caretakers-table.vue?vue&type=template&id=7e545fdc&"
import script from "./caretakers-table.vue?vue&type=script&lang=ts&"
export * from "./caretakers-table.vue?vue&type=script&lang=ts&"
import style0 from "./caretakers-table.vue?vue&type=style&index=0&id=7e545fdc&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports